/* eslint-disable no-console */
import {useTranslation} from "react-i18next";
import {useFeedback} from "../feedback";
import {ErrorHandler} from "./ErrorHandler";

export function useToastErrorHandler(): ErrorHandler {
  const {t} = useTranslation();
  const [, setFeedback] = useFeedback();
  return error => {
    console.error(error);
    setFeedback({
      message: t("toast.backend-error", "???"),
      type: "error",
      autoHide: true,
      action: {
        label: "View Details",
        onClick: () => {
          const details = window.open("/error-details", "_blank");
          if (details) {
            details.error = error;
          }
        }
      }
    });
  };
}
